import {Typography} from '@mui/material'
import type {FC} from 'react'
import {useCustomTranslation} from '@hooks/useCustomTranslation'

type Props = {
  step: string | number | null | undefined
  stepDescription?: string
}

const StepDescription: FC<Props> = ({step, stepDescription}) => {
  const [t] = useCustomTranslation('anomalies')

  // A state of 0 / "0" (e.g. "False") is a real state, so only an absent value
  // hides the row — `!step` used to drop it (AB#5666).
  const text = step === null || step === undefined ? '' : String(step).trim()

  return text === '' || text === 'None' ? null : (
    <Typography
      data-testid="step-description"
      variant="body2"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {`${t('step')} ${text}${stepDescription ? ` (${stepDescription})` : ''}`}
    </Typography>
  )
}

export default StepDescription
